/**
 * Registration roles
 */
export class Role {
    public static SELF: string = 'self';
    public static PARENT: string = 'parent';
    public static COACH: string = 'coach';
    public static INVITED_COACH: string = 'invited-coach';
    public static ADMIN: string = 'admin';
}
